var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24.00 24.00",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.00024000000000000003,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    d: "M22,11V7.83L12,2.06,2,7.83V11H4v8H2v2H22V19H20V11ZM4,9l8-4.62L20,9H4ZM6,19V11H8v8Zm4,0V11h4v8Zm8,0H16V11h2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsvg);
export default __webpack_public_path__ + "static/media/accountsvg.28bcd4001191d5f3b61a5252340c1e07.svg";
export { ForwardRef as ReactComponent };